module.exports = __webpack_public_path__ + "static/img/brand_4.d818b5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/brand_4.jpg
// module id = S48g
// module chunks = 1